import React from 'react';
import { Tooltip } from '@mui/material';
import ToolTipContent from '../toolTipContent';
import Offsite from './offsite';

const OffsiteWrapper = (props) => {
   if (props.dayStatus && props.dayStatus.offsiteName !== null) {
      return (
         <Tooltip
            title={<ToolTipContent dayStatus={props.dayStatus} />}
            placement="top"
            arrow
         >
            <div>
               <Offsite
                  clickable={props.clickable}
                  styles={props.styles}
                  miniChips={props.miniChips}
                  bookings={true}
                  data={props.data}
                  setSpaceData={props.setSpaceData}
                  setStatusDrawerOpen={props.setStatusDrawerOpen}
               />
            </div>
         </Tooltip>
      );
   } else if (props.dayStatus && props.dayStatus.times) {
      return (
         <Tooltip
            title={<ToolTipContent dayStatus={props.dayStatus} />}
            placement="top"
            arrow
         >
            <div>
               <Offsite
                  clickable={props.clickable}
                  styles={props.styles}
                  miniChips={props.miniChips}
                  bookings={false}
                  data={props.data}
                  setSpaceData={props.setSpaceData}
                  setStatusDrawerOpen={props.setStatusDrawerOpen}
               />
            </div>
         </Tooltip>
      );
   } else {
      return (
         <Offsite
            clickable={props.clickable}
            styles={props.styles}
            miniChips={props.miniChips}
            bookings={false}
            data={props.data}
            setSpaceData={props.setSpaceData}
            setStatusDrawerOpen={props.setStatusDrawerOpen}
         />
      );
   }
};
export default OffsiteWrapper;
